// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__28aNr","questions":"styles_questions__rBzBr","footer":"styles_footer__2d9Zl"};